import React from 'react';
import download from 'downloadjs';
import mime from 'mime';

export function Download({ children, siteFileId, filename, ...props }) {
  const downloadLink = `/common/downloadFileSite?siteFileId=${siteFileId}`;
  const handlerClick = (e) => {
    e.preventDefault();

    fetch(downloadLink)
      .then((res) => {
        let contentBuffer = new Int8Array();

        const reader = res.body.getReader();

        const handleChunk = ({ done, value }) => {
          if (done) {
            const mimeType = mime.getType(filename);
            download(contentBuffer, filename, mimeType);
            return;
          }

          contentBuffer = Int8Array.from([...contentBuffer, ...value]);

          reader.read().then(handleChunk);
        };

        reader.read().then(handleChunk);
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <a href={downloadLink} onClick={handlerClick} {...props}>
        {children}
      </a>
    </>
  );
}
